import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import Visualizza_presenze_per_alunno from "./progetto_x2_presenze_lista_per_alunno.jsx";
import Visualizza_singolo_progetto from "./Progetto_x9_visualizza_singolo_progetto.jsx";
//import JSONPretty from 'react-json-pretty';

const Visualizza_elenco_presenze_di_un_anno = (props) => {
//    const [somma, calcola_somma] = useState('');
    return (
        <>
                {/* idroslab check se il map si può fare */}

        {Array.isArray(props.lista_progetti_anno_scolastico) && props.lista_progetti_anno_scolastico.map(function (item, index2) {
            {
                return <>
                        
                     {/*    <JSONPretty data={item} /> */}
                   
                      <Visualizza_singolo_progetto progetto={item} />
                    <Visualizza_presenze_per_alunno progetto={item} />
                    <p> {' .'}</p>
                    <p> {' .'}</p>

                </>
            }
            })
        }
        </>
    )
}
export default Visualizza_elenco_presenze_di_un_anno;